import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CHANGE_PASSWORD_TRANSLATION_NAMESPACE, STATUS_ERROR } from 'consts';
import { STATUS_SUCCESS } from 'consts/common';
import { Context } from 'context/Context';
import { EnelXGuiAtoms } from 'gui';
// import { t } from 'i18n_new';
import { ContainerChangePassword, TitelText } from 'pages/changePassword/styles';
import PropTypes from 'prop-types';
import { isItEmpty, QuestionWrapper } from 'utils';

import MainInput from 'components/MainInput';

const {
  MigrationButton,
} = EnelXGuiAtoms;

const FormPassword = ({
  formData,
  errorFields,
  handleChange,
  handleUtility,
  isFormValid,
}) => {
  const { t } = useTranslation(CHANGE_PASSWORD_TRANSLATION_NAMESPACE);
  const { api } = useContext(Context);

  const cb = (value) => handleUtility('pswStatus', value);

  const handleSubmit = async () => api.auth.changePassword(
    formData.newPassword,
    formData.newPasswordCheck,
    () => cb(STATUS_SUCCESS),
    () => cb(STATUS_ERROR.toLocaleLowerCase()),
  );

  const isNewPswOnErr = !isItEmpty(errorFields?.newPassword);
  const isNewPswCheckOnErr = !isItEmpty(errorFields?.newPasswordCheck);

  return (
    <ContainerChangePassword>
      <div className="titelTexts">
        <TitelText Titel="titel">{t('enterTheNewPassword')}</TitelText>
        <TitelText Titel="sub">
          {t('enterTheNewPasswordAtLeastEight')}
        </TitelText>
      </div>
      <div style={{ width: '60%' }}>
        <QuestionWrapper>
          <MainInput
            id="password"
            label={t('newPassword')}
            onChange={(e) => handleChange('newPassword', e.target.value)}
            value={formData?.newPassword ?? ''}
            errorMessage={isNewPswOnErr ? errorFields?.newPassword?.message : null}
          />
        </QuestionWrapper>
        <QuestionWrapper>
          <MainInput
            id="password"
            label={t('confirmPassword')}
            onChange={(e) => handleChange('newPasswordCheck', e.target.value)}
            value={formData?.newPasswordCheck ?? ''}
            errorMessage={isNewPswCheckOnErr ? errorFields?.newPasswordCheck?.message : null}
          />
        </QuestionWrapper>
        <div className="confirm-btn">
          <MigrationButton
            btnText={t('confirm')}
            btnType="primary"
            disabled={!isFormValid}
            onClick={handleSubmit}
          />
        </div>
      </div>
    </ContainerChangePassword>
  );
};

FormPassword.propTypes = {
  formData: PropTypes.shape({
    newPassword: PropTypes.string,
    newPasswordCheck: PropTypes.string,
  }).isRequired,
  errorFields: PropTypes.shape().isRequired,
  handleChange: PropTypes.func.isRequired,
  utility: PropTypes.shape({
    isPswVisible: PropTypes.bool,
    isPswCheckVisible: PropTypes.bool,
  }).isRequired,
  isFormValid: PropTypes.bool.isRequired,
  handleUtility: PropTypes.func.isRequired,
};

export default FormPassword;
